/**
 * 共通ブランドヘッダ。会社のロゴ (NEW WORK STYLE LAB) を画面上部に表示する。
 * 全打刻フロー (SelectName / PinEntry / Punch / PunchSuccess) で使用。
 */
export function BrandHeader() {
  return (
    <div className="brand-header">
      <img src="/logo.png" alt="New Work Style Lab" className="brand-logo" />
    </div>
  );
}
